module.exports = __webpack_public_path__ + "static/img/science.0c106c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/science.png
// module id = RUuL
// module chunks = 16